// URL base de la API — se inyecta automáticamente desde el archivo .env correspondiente
export const API = process.env.REACT_APP_API_URL;
